import React from 'react';
import { Lock, ArrowUpCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';

interface UpgradeBannerProps {
  title?: string;
  description?: string;
  onUpgrade?: () => void;
  minimal?: boolean;
}

export const UpgradeBanner: React.FC<UpgradeBannerProps> = ({ 
  title = "Upgrade to Unlock", 
  description = "This feature is available on the Pro plan and above.",
  onUpgrade,
  minimal = false
}) => {
  
  if (minimal) {
    return (
      <div className="flex items-center justify-between p-4 border border-amber-200 bg-amber-50 rounded-lg text-amber-900">
        <div className="flex items-center gap-2">
          <Lock className="h-4 w-4" />
          <span className="text-sm font-medium">{title}</span>
        </div>
        <Button size="sm" variant="outline" onClick={onUpgrade} className="border-amber-500 text-amber-700 hover:bg-amber-100">
          Upgrade
        </Button>
      </div>
    );
  }

  return (
    <Card className="border-dashed border-2 border-amber-200 bg-amber-50/50">
      <CardHeader className="text-center pb-2">
        <div className="mx-auto bg-amber-100 p-3 rounded-full w-fit mb-2">
          <Lock className="h-6 w-6 text-amber-600" />
        </div>
        <CardTitle className="text-xl text-amber-900">{title}</CardTitle>
        <CardDescription className="text-amber-700 max-w-md mx-auto">
          {description}
        </CardDescription>
      </CardHeader>
      <CardFooter className="justify-center pb-6">
        <Button onClick={onUpgrade} className="bg-amber-600 hover:bg-amber-700 text-white gap-2">
          <ArrowUpCircle className="h-4 w-4" />
          View Plans
        </Button>
      </CardFooter>
    </Card>
  );
};
